import { useEffect, useState } from 'react';

import { EntryDraftServerEvents } from 'chaika-frontend-types/server-events';
import type { EntryDraftCreatedEventData } from 'chaika-frontend-types/server-events/entry-draft';

import { ServerEventBus } from '@core/ServerEvents';
import { store } from '@store';
import { queryClient } from '@store/queryClient';

import { draftEntriesKeys } from '../queries/draftEntriesQueries';
import { resolveAssignedDoctorIds } from '../utils/resolveAssignedDoctorIds';

interface Data {
    isDismissed: boolean;
    dismiss: () => void;
}

export function useDraftEntriesBannerDismissal(): Data {
    const [isDismissed, setIsDismissed] = useState(false);

    useEffect(() => {
        const serverEventBus = ServerEventBus.getInstance();

        const listener = ({ body }: EntryDraftCreatedEventData) => {
            const { authUser } = store;

            if (body.authorId === authUser.id || !resolveAssignedDoctorIds(authUser).includes(body.doctorId)) {
                return;
            }

            queryClient.invalidateQueries({ queryKey: draftEntriesKeys.all });
            setIsDismissed(false);
        };

        serverEventBus.addEventListener(EntryDraftServerEvents.EntryDraftEvents.Created, listener);

        return () => {
            serverEventBus.removeEventListener(EntryDraftServerEvents.EntryDraftEvents.Created);
        };
    }, []);

    return { isDismissed, dismiss: () => setIsDismissed(true) };
}
